export function uniqueArray<T, P>(array: T[], propertyExtractor: (item: T) => P) {
  return array.filter(
    (value, index, self) =>
      index === self.findIndex((t) => propertyExtractor(t) === propertyExtractor(value)),
  )
}
